import { Button, colors, Input } from "@thetreep/ui";
import { FieldError } from "./FieldError";

export interface NumberInputProps {
  label: string;
  value: number | undefined;
  min?: number;
  max?: number;
  error?: string;
  onChange: (v: number | undefined) => void;
}

export function NumberInput({
  label,
  value,
  min,
  max,
  error,
  onChange,
}: NumberInputProps) {
  function parseNumber(s: string): number | undefined {
    const v = parseInt(s, 10);
    return isNaN(v) ? undefined : v;
  }

  function handleChange(v: string | number) {
    const i =
      typeof v === "string"
        ? parseNumber(v.toString().replace(/[^0-9]/g, ""))
        : v;
    if (i == undefined) {
      onChange(i);
      return;
    }
    if (min !== undefined && i < min) {
      return;
    }
    if (max !== undefined && i > max) {
      return;
    }
    onChange(i);
  }

  return (
    <div className="flex flex-col gap-2">
      <span className="text-xs font-bold">{label}</span>
      <div className="flex items-center gap-4">
        <Button
          size="mini"
          kind="outline"
          onClick={() => handleChange((value || 0) - 1)}
          colors={{
            color: colors.primaryStrong,
            backgroundColor: colors.primaryStrong,
          }}
        >
          -
        </Button>
        <div className="[&>div]:max-h-10 [&>div]:max-w-16">
          <Input
            value={value}
            min={0}
            onChange={(e) => handleChange(e.target.value)}
          ></Input>
        </div>
        <Button
          size="mini"
          kind="outline"
          onClick={() => handleChange((value || 0) + 1)}
          colors={{
            color: colors.primaryStrong,
            backgroundColor: colors.primaryStrong,
          }}
        >
          +
        </Button>
      </div>
      <FieldError error={error} />
    </div>
  );
}
